import Notification from 'components/Notification'
import { createContext, useContext, useState } from 'react'

const BaseContext = createContext({ actions: {} });

const BaseProvider = ({ children }) => {
  const [toastProps, setToastProps] = useState(false)
  const [toggleToast, setToggleToast] = useState(false)

  const defaultValue = {
    toastProps,
    toggleToast,

    actions: {
      closeNotification: () => setToggleToast(false),
      setNotification: (props) => {
        setToastProps(props)
        setToggleToast(true)
      },
    },
  }

  return (
    <BaseContext.Provider value={defaultValue}>
      {children}
      <Notification />
    </BaseContext.Provider>
  )
}

const useBaseContext = () => {
  return useContext(BaseContext)
}

export { BaseProvider, useBaseContext }
export default BaseContext